// Storage keys
export const NUTRITION_KEY = 'gym_notebook_nutrition';
export const NUTRITION_GOALS_KEY = 'gym_notebook_nutrition_goals';
export const SAVED_BARCODES_KEY = 'gym_notebook_saved_barcodes';
export const SAVED_MEALS_KEY = 'gym_notebook_saved_meals';
export const CUSTOM_MEAL_TIMES_KEY = 'gym_notebook_custom_meal_times';
export const EXTERNAL_STEPS_KEY = 'gym_notebook_external_steps';
export const CUSTOM_PRODUCTS_KEY = 'gym_notebook_custom_products';

// Default nutrition goals
export const DEFAULT_GOALS = {
  calories: 2000,
  protein: 150,
  carbs: 200,
  fat: 65,
};

// Default meal times
export const DEFAULT_MEAL_TIMES = [
  { id: 'breakfast', name: 'Breakfast', icon: '🌅' },
  { id: 'lunch', name: 'Lunch', icon: '☀️' },
  { id: 'dinner', name: 'Dinner', icon: '🌙' },
  { id: 'snack', name: 'Snack', icon: '🍎' },
];

// Open Food Facts API (primary: .net, fallback: .org)
export const OPEN_FOOD_FACTS_API = 'https://world.openfoodfacts.net';

// Default BMR data structure
export const DEFAULT_BMR_DATA = {
  bmr: 0,
  activityLevel: 1.2,
  tdee: 0,
  goal: 'maintain',
  dailyTarget: 0,
  walkCalories: 0,
  workoutCalories: 0,
  externalStepsActive: false,
  calorieAdjustment: 0,
  cycleWeek: 0,
  cyclePhase: '',
  weekNumber: 0,
};

// Default manual entry structure
export const DEFAULT_MANUAL_ENTRY = {
  name: '',
  calories: '',
  protein: '',
  carbs: '',
  fat: '',
  grams: '100',
  barcode: ''
};
